import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"border-bottom":"1px #eee solid"},
  class: /*#__PURE__*/_normalizeClass(`roomTableTrContent posRe`)
}
const _hoisted_2 = {
  key: 0,
  colspan: "3",
  class: "roomTableChildMembers",
  style: {"padding":"10px 0"}
}
const _hoisted_3 = {
  class: "fl posRe",
  style: {"width":"420px"}
}
const _hoisted_4 = {
  key: 0,
  class: "fs8 centered greyColor fl",
  style: {"line-height":"12px"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fw600" }
const _hoisted_7 = {
  key: 0,
  class: "fs12 fw600"
}
const _hoisted_8 = {
  key: 1,
  class: "fr"
}
const _hoisted_9 = {
  class: "dropdown-toggle fw600 fr centered fs12 noborder",
  style: {"width":"30px","margin-top":"-8px","background-color":"transparent","outline":"none"}
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "fr mt3 mr20 mr4",
  style: {"width":"120px"}
}, " フォームに事前入力したURLを生成 ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = {
  class: "fl posAb",
  style: {"width":"450px","left":"420px"}
}
const _hoisted_20 = { style: {"height":"24px"} }
const _hoisted_21 = {
  class: "fs12 dblue fw600 arial posAb",
  style: {"height":"20px","left":"372px"}
}
const _hoisted_22 = {
  class: "fs12 dblue fw600 arial posAb",
  style: {"height":"20px","left":"248px"}
}
const _hoisted_23 = {
  class: "fs12 dblue fw600 arial posAb",
  style: {"height":"20px","left":"124px"}
}
const _hoisted_24 = {
  class: "fs12 dblue fw600 arial posAb",
  style: {"height":"20px","left":"0px"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"22px","height":"22px","border-radius":"50%","margin-left":"25px"},
  class: "dblueBg fl"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: ""
}
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt6 fw600" }, "フォーム内容を確認", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_ctx.step >= 0)
    ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        (!_ctx.isSP)
          ? (_openBlock(), _createElementBlock("td", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.showIcon)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                      _createTextVNode("   "),
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/email/${_ctx.getImgUrl()}`),
                        width: "32",
                        height: "32",
                        class: "fl",
                        style: {"margin-left":"40px","margin-top":"2px"}
                      }, null, 8, _hoisted_5),
                      _createElementVNode("span", {
                        class: _normalizeClass(`fl fw600 ${[1, 2, 3].includes(_ctx.step) ? `greenColor` : ``}`),
                        style: {"margin-top":"12px"}
                      }, "    " + _toDisplayString(_ctx.getStatusText()), 3)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(`fl ${_ctx.isSP ? `fs17` : `fs14`}`),
                  style: { marginTop: `10px`, marginLeft: `20px`, width: `260px` }
                }, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.mem.name), 1),
                  (_ctx.mem.company_name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.mem.company_name) + ")", 1))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_Dropdown, {
                          ref: "dropdown",
                          class: "",
                          style: {"min-width":"30px"}
                        }, {
                          dropdown: _withCtx(() => [
                            _createElementVNode("li", {
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createFeedback && _ctx.createFeedback(...args))),
                              class: "fs12 pointer fw600 pad5",
                              style: {"line-height":"40px","width":"180px"}
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                                width: "16",
                                height: "17",
                                class: "ml7 fl mt4 mr5",
                                style: {}
                              }, null, 8, _hoisted_11),
                              _hoisted_12,
                              _hoisted_13
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("button", _hoisted_9, [
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/line3.png`),
                                width: "25",
                                height: "25",
                                class: "fr pointer"
                              }, null, 8, _hoisted_10)
                            ])
                          ]),
                          _: 1
                        }, 512),
                        _hoisted_14
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: _normalizeClass(`fl ${_ctx.isSP ? `fs17` : `fs11`} grey`),
                    style: { marginTop: `3px`, width: `240px` }
                  }, [
                    (_ctx.Util.isSMSEmail(_ctx.mem.email))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.telephoneNum), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.mem.email), 1))
                  ], 2),
                  _hoisted_17,
                  (!_ctx.room.is_expired && _ctx.mem.role != 100)
                    ? (_openBlock(), _createElementBlock("section", {
                        key: 2,
                        class: "pointer circle_button greenBg fs13 fl centered noborder rad6 fw600 mt10",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remindUser(_ctx.mem)))
                      }, " リマインドする "))
                    : _createCommentVNode("", true),
                  _hoisted_18
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.updatedAtTextStep3), 1),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.updatedAtTextStep2), 1),
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.updatedAtTextStep1), 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.room.createdAtText.replace(` `, `\n`)), 1)
                ]),
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", {
                  style: {"width":"102px","height":"4px","margin-top":"10px"},
                  class: _normalizeClass(`${_ctx.step < 1 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2),
                _createElementVNode("div", {
                  style: {"width":"22px","height":"22px","border-radius":"50%"},
                  class: _normalizeClass(`${_ctx.step < 1 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2),
                _createElementVNode("div", {
                  style: {"width":"102px","height":"4px","margin-top":"10px"},
                  class: _normalizeClass(`${_ctx.step < 2 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2),
                _createElementVNode("div", {
                  style: {"width":"22px","height":"22px","border-radius":"50%"},
                  class: _normalizeClass(`${_ctx.step < 2 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2),
                _createElementVNode("div", {
                  style: {"width":"102px","height":"4px","margin-top":"10px"},
                  class: _normalizeClass(`${_ctx.step < 3 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2),
                _createElementVNode("div", {
                  style: {"width":"22px","height":"22px","border-radius":"50%"},
                  class: _normalizeClass(`${_ctx.step < 3 ? `lgreyBg` : `dblueBg`} fl`)
                }, null, 2)
              ]),
              _hoisted_27
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("td", null, [
          (_ctx.mem.answered_status == `done`)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: "rad8 pointer centered circle_button blueAround fl padw5",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickFormMember && _ctx.clickFormMember(...args)))
                }, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                    width: "20",
                    height: "21",
                    class: "fl mr10 mt3",
                    style: {}
                  }, null, 8, _hoisted_29),
                  _hoisted_30
                ]),
                _hoisted_31
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}